import React from 'react';
import { useTheme } from '@veneer/theme';
var useStyles = _ref => {
  var {
    spacing
  } = _ref;
  var theme = useTheme();
  return React.useMemo(() => {
    var spacingValue = theme.layout["size".concat(spacing)] || theme.layout.size3;
    return {
      root: {
        display: 'flex',
        flexDirection: 'row',
        ["@media (min-width: ".concat(theme.layout.smMin, ")")]: {
          '> button:not(:last-child)': {
            margin: 0,
            marginRight: spacingValue
          }
        },
        ["@media (max-width: ".concat(theme.layout.smMin, ")")]: {
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          '> button': {
            display: 'flex',
            width: '100%'
          },
          '> button:not(:last-child)': {
            margin: 0,
            marginBottom: spacingValue
          }
        }
      }
    };
  }, [spacing, theme]);
};
export default useStyles;